import {getGroupProduct} from 'ApplicationEntry/api/awdApi';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import * as A from 'ApplicationEntry/ducks/ProductsRiders/aip';
import {push} from 'connected-react-router';
import {AsyncResult, Loaded} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';


function* getPackageList() {
  yield takeLatest(A.AIPActionType.GET_PACKAGE_LIST, function*(
    action: ReturnType<typeof A.getPackages>
  ) {
    const {payload} = action;
    const {caseNumber, planCode} = payload;
    
    const response: AsyncResult<{packages: object[]}> = yield call(getGroupProduct, caseNumber, planCode);
    if (E.isRight(response)) {
      yield put(A.changePackageList(new Loaded(response.right.packages)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(A.changePackageList(response.left));
    }
  });
}

export default function*() {
  yield all([getPackageList()]);
}
